import { useCallback } from "react";
import { logOfficeError } from "../../telemetry";
import { openExistingAppointment } from "../../../integrations/tools/outlook/appointment";

/**
 * useOpenCalendarEvent returns a handler that opens an existing calendar
 * appointment inside the Outlook client, the same way clicking a meeting
 * in the calendar grid does (popup with full event details).
 *
 * The host ladder lives in `integrations/tools/outlook/appointment.ts` — the
 * CM-01 Graph booking fallback opens its freshly created event through the
 * same code.
 */
export function useOpenCalendarEvent(): (itemId: string, webLink: string) => void {
  return useCallback((itemId: string, webLink: string) => {
    try {
      openExistingAppointment(itemId, webLink);
    } catch (err) {
      console.warn("[useOpenCalendarEvent] Failed to open appointment:", err);
      logOfficeError(err, "outlook-open-appointment");
      window.open(webLink, "_blank");
    }
  }, []);
}
